var path = './dboard/title_bar.html';
var html = "<div role=\"menu\" class=\"menu\" ng-if=\"authenticated\">\n    <div class=\"menu-row\">\n        <span class=\"menu-text\" style=\"font-weight: bold;\">{{'DBOARD.MENU.DASHBOARD'|translate}}</span>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;